import { __awaiter, __generator } from "tslib";
import { addNcpcCode } from '@ekuaibao/lib/lib/addNcpcCode';
import { app, callback } from '../index.v0';
import QYWeiXinSDK from '@ekuaibao/sdk-bridge/sdk/qyweixin';
import registerAPI from '../registerAPI';
import { localCacheSet } from '@ekuaibao/session-info';
import registerHandler from '../registerHandler';
import initializeTitle from '../initializeTitle';
import initPlatformInfo from '../initPlatformInfo';
import { initColors } from '../initColors';
window.__PLANTFORM__ = 'WEIXIN';
window.APPLICATION_VERSION = APPLICATION_VERSION;
function redirect() {
    var params = (function () {
        var arr = location.search.slice(1).split('&');
        var obj = {};
        for (var i = 0; i < arr.length; i++) {
            var arr2 = arr[i].split('=');
            obj[arr2[0]] = decodeURIComponent(arr2[1]);
        }
        return obj;
    })();
    return new Promise(function (resolve, reject) {
        var billState = params.billState;
        switch (billState) {
            case 'APPROVING':
            case 'SENDING':
            case 'RECEIVING':
            case 'PROCESSED':
                localCacheSet('beforePage', 'auditPending', true);
                resolve('/audit/approve');
                break;
            case 'PAYING':
                localCacheSet('beforePage', 'auditPayment', true);
                resolve('/audit/payment');
                break;
            case 'comment':
                localCacheSet('beforePage', 'auditCarbonCopy', true);
                resolve('/audit/carbonCopy');
                break;
            default:
                reject(i18n.get('参数错误'));
        }
    });
}
function startup(hash) {
    app.use({
        id: '@weixin',
        onready: function () {
            addNcpcCode();
        }
    });
    app.useHistory({
        search: location.search.slice(1),
        initialEntries: [hash]
    });
    callback();
}
export var bootstrap = function () { return __awaiter(void 0, void 0, void 0, function () {
    var hash;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                app.container.set('IDeviceType', 'DESKTOP');
                app.container.set('ISMessageEntry', true);
                app.sdk = app.container.get(QYWeiXinSDK);
                initColors();
                initPlatformInfo();
                registerHandler();
                return [4, app.sdk.initialize()];
            case 1:
                _a.sent();
                window.isNewHome = true;
                initializeTitle();
                registerAPI();
                return [4, redirect()];
            case 2:
                hash = _a.sent();
                startup(hash);
                return [2];
        }
    });
}); };
